import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Carlos M.",
    city: "Ribeirão Preto",
    text: "Chegaram muito rápido e resolveram meu problema na hora. Profissionais atenciosos e frota impecável. Recomendo demais!",
  },
  {
    name: "Fernanda R.",
    city: "Ribeirão Preto",
    text: "Atendimento excelente e preço justo. Tive meu carro rebocado com toda segurança até a oficina. Serviço sério!",
  },
  {
    name: "Juliano P.",
    city: "Sertãozinho",
    text: "Precisava de um guincho urgente na madrugada e foram super rápidos. Equipe educada e profissional. Salvou meu dia!",
  },
  {
    name: "Patrícia L.",
    city: "Bonfim Paulista",
    text: "Ficaram em linha comigo até chegarem. Transparência no preço e cuidado total com o veículo. Nota 10!",
  },
  {
    name: "Rodrigo S.",
    city: "Cravinhos",
    text: "Já usei em 3 emergências diferentes. Sempre rápidos, sempre honestos. É meu guincho de confiança em Ribeirão.",
  },
  {
    name: "Marcos V.",
    city: "Ribeirão Preto",
    text: "Transportaram minha moto com todo cuidado para uma oficina específica. Melhor custo-benefício da região.",
  },
];

export const Testimonials = () => {
  return (
    <section
      id="depoimentos"
      data-testid="testimonials-section"
      className="section-pad bg-[#0a0a0a] relative overflow-hidden"
    >
      <div className="container-custom">
        <div className="max-w-3xl mb-12">
          <span className="overline">Depoimentos Reais</span>
          <h2 className="mt-3 font-display uppercase font-bold text-white text-4xl md:text-5xl leading-tight tracking-tight">
            O que nossos{" "}
            <span className="text-[#d90429]">clientes dizem</span>
          </h2>
          <div className="mt-5 flex items-center gap-4">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="w-5 h-5 text-yellow-400 fill-yellow-400"
                />
              ))}
            </div>
            <span className="text-white font-display uppercase tracking-wider">
              5.0 · 127 avaliações
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {REVIEWS.map((r, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i}`}
              className="card-dark p-7 relative"
            >
              <Quote className="absolute top-6 right-6 w-10 h-10 text-[#d90429]/20" />
              <div className="flex mb-4">
                {[...Array(5)].map((_, j) => (
                  <Star
                    key={j}
                    className="w-4 h-4 text-yellow-400 fill-yellow-400"
                  />
                ))}
              </div>
              <p className="text-gray-200 leading-relaxed mb-6">
                "{r.text}"
              </p>
              <div className="pt-4 border-t border-[#2d3748]">
                <div className="font-display uppercase font-bold text-white tracking-wider">
                  {r.name}
                </div>
                <div className="text-xs text-gray-500 uppercase tracking-wider mt-1">
                  {r.city}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
